<app-packaging-system-tree [packagingSystem]="packagingSystem" [isDarkTheme]="isDarkTheme" [includeRoot]="true"
  [includeComponents]="false" [deselectionAllowed]="false" (nodeSelected)="onNodeSelected($event)">
</app-packaging-system-tree>

<app-packaging-navigation [itemId]="packagingSystem.id" [callerLevelId]="packagingPartType"
  [callerTypeId]="packagingPart.System" [currentDirectoryId]="packagingSystem.directoryId" [brandName]="packagingSystem.brandName"
  [productName]="packagingSystem.productName" [articleNumber]="packagingSystem.articleNumber"
  [versionId]="packagingSystem.version" [isCurrentVersion]="packagingSystem.isCurrentVersion"
  [hasRecyclabilityResult]="packagingSystem.hasRecyclabilityResult" [hasLifeCycleResult]="packagingSystem.hasLifeCycleResult"
  [creationTimestamp]="packagingSystem.creationTimestamp">

  <mat-tab-group dynamicHeight>
    <mat-tab [label]="'analysis.expenseCalculation.licenseFee.title' | translate">
      <div class="tab-container">
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFee' | translate"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.ecomodulation' | translate"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFeeVsEcomodulation' | translate"></p>
        <app-expense-calculation-html-template [expenseResults]="dataSource" [displayType]="displayType.licenseFee" [packagingPart]="packagingSystem"
          [packagingPartType]="packagingPartType" [title]="'analysis.expenseCalculation.licenseFee.title' | translate"
          [licenseFeeCountries]="licenseFeeCountries" [ecomodulationCountries]="ecomodulationCountries" [plasticTaxCountries]="plasticTaxCountries"
          disclaimer="{{ 'analysis.expenseCalculation.licenseFee.disclaimer' | translate }}">
        </app-expense-calculation-html-template>
      </div>
    </mat-tab>

    <mat-tab [label]="'analysis.expenseCalculation.plasticTax.title' | translate">
      <div class="tab-container">
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.plasticTax'| translate"></p>
        <app-expense-calculation-html-template [expenseResults]="dataSource" [displayType]="displayType.plasticTax" [packagingPart]="packagingSystem"
          [packagingPartType]="packagingPartType" [title]="'analysis.expenseCalculation.plasticTax.title' | translate"
          [licenseFeeCountries]="licenseFeeCountries" [ecomodulationCountries]="ecomodulationCountries" [plasticTaxCountries]="plasticTaxCountries">
        </app-expense-calculation-html-template>
      </div>
    </mat-tab>

    <mat-tab [label]="'analysis.expenseCalculation.total.title' | translate">
      <div class="tab-container">
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFee' | translate"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.ecomodulation' | translate"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFeeVsEcomodulation' | translate"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.plasticTax'| translate"></p>
        <app-expense-calculation-html-template [expenseResults]="dataSource" [displayType]="displayType.total" [packagingPart]="packagingSystem"
          [packagingPartType]="packagingPartType" [title]="'analysis.expenseCalculation.total.title' | translate"
          [licenseFeeCountries]="licenseFeeCountries" [ecomodulationCountries]="ecomodulationCountries" [plasticTaxCountries]="plasticTaxCountries"
          disclaimer="{{ 'analysis.expenseCalculation.total.disclaimer' | translate }}">
        </app-expense-calculation-html-template>
      </div>
    </mat-tab>
  </mat-tab-group>



</app-packaging-navigation>
